<template>
  <b-modal
    v-model="showModal"
    title="Đóng case khiếu nại"
    size="md"
    ok-title="Đóng case"
    cancel-title="Hủy"
    @ok="handleOk"
    @hidden="resetForm"
    :ok-disabled="submitting"
    hide-backdrop
  >
    <b-form>
      <b-form-group label="Kết quả (chọn 1 trong 3)" label-for="closeResultStatus">
        <b-form-select
          id="closeResultStatus"
          class="select-style"
          v-model="form.closeResultStatus"
          :options="closeResultOptions"
          value-field="value"
          text-field="text"
          placeholder="Chọn kết quả"
        >
          <template #first>
            <b-form-select-option :value="null"
              >Chọn kết quả đóng case</b-form-select-option
            >
          </template>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Số tiền được bồi hoàn" label-for="compensationAmount">
        <BInputNumber
          id="compensationAmount"
          v-model="form.compensationAmount"
          size="sm"
          placeholder="VD: 500000"
        />
      </b-form-group>
      <b-form-group label="Số tiền tổn thất" label-for="lossAmount">
        <BInputNumber
          id="lossAmount"
          v-model="form.lossAmount"
          size="sm"
          placeholder="Tự động: orderAmount - compensationAmount"
        />
      </b-form-group>
    </b-form>
    <template #modal-footer>
      <b-button variant="secondary" @click="showModal = false">Hủy</b-button>
      <b-button variant="primary" @click="handleSubmit" :disabled="submitting">
        <b-spinner v-if="submitting" small></b-spinner>
        <span v-else>Đóng case</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { getToastInstance } from '@/utils/toastHelper';
import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue';

const shopeeAdminRepo = RepositoryFactory.get('shopeeAdmin');
const toast = getToastInstance();

const CLOSE_RESULT_OPTIONS = [
  { value: 'money_recovered', text: 'Đã thu hồi tiền' },
  { value: 'company_support', text: 'Công ty hỗ trợ khách' },
  { value: 'accept_loss', text: 'Chấp nhận mất' },
];

export default {
  name: 'CloseCaseModal',
  components: { BInputNumber },
  data() {
    return {
      showModal: false,
      submitting: false,
      complaintId: null,
      orderAmount: 0,
      form: {
        closeResultStatus: null,
        compensationAmount: null,
        lossAmount: null,
      },
    };
  },
  computed: {
    closeResultOptions() {
      return CLOSE_RESULT_OPTIONS;
    },
  },
  watch: {
    'form.compensationAmount'(val) {
      if (this.orderAmount != null && val != null && val !== '') {
        const comp = Number(val);
        const order = Number(this.orderAmount) || 0;
        this.form.lossAmount = Math.max(0, order - comp);
      }
    },
  },
  methods: {
    open(item) {
      this.complaintId = item.id;
      this.orderAmount = item.orderAmount ?? 0;
      this.form.closeResultStatus = item.closeResultStatus ?? null;
      this.form.compensationAmount = item.compensationAmount ?? null;
      this.form.lossAmount =
        item.lossAmount ??
        (this.orderAmount != null && this.form.compensationAmount != null
          ? Math.max(0, Number(this.orderAmount) - Number(this.form.compensationAmount))
          : null);
      this.showModal = true;
    },
    resetForm() {
      this.complaintId = null;
      this.orderAmount = 0;
      this.form = {
        closeResultStatus: null,
        compensationAmount: null,
        lossAmount: null,
      };
    },
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.handleSubmit();
    },
    async handleSubmit() {
      try {
        this.submitting = true;
        const orderAmt = Number(this.orderAmount) || 0;
        const compAmt =
          this.form.compensationAmount != null && this.form.compensationAmount !== ''
            ? Number(this.form.compensationAmount)
            : 0;
        const lossAmt =
          this.form.lossAmount != null && this.form.lossAmount !== ''
            ? Number(this.form.lossAmount)
            : Math.max(0, orderAmt - compAmt);

        const payload = {
          closeResultStatus: this.form.closeResultStatus || undefined,
          compensationAmount: compAmt,
          lossAmount: lossAmt,
        };

        await shopeeAdminRepo.closeComplaint(this.complaintId, payload);
        toast.makeToastSuccess('Đã đóng case thành công');
        this.showModal = false;
        this.$emit('closed');
      } catch (error) {
        const msg =
          error?.response?.data?.message || 'Không thể đóng case';
        toast.makeToastFailure(msg);
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
